import React, { useState } from 'react';
import { SurveyForm } from './components/SurveyForm';
import './styles/app.css';

export const App: React.FC = () => {
  const [surveyCompleted, setSurveyCompleted] = useState(false);
  const [finalScore, setFinalScore] = useState<number | null>(null);

  const handleSurveySuccess = (score: number) => {
    setFinalScore(score);
    setSurveyCompleted(true);
  };

  return (
    <div className="app-container">
      <header className="app-header">
        <div className="header-content">
          <h1 className="app-title">Auricle Inc. - SUS Survey</h1>
          <p className="app-subtitle">System Usability Scale Assessment</p>
        </div>
      </header>

      <main className="app-main">
        {surveyCompleted && finalScore !== null ? (
          <div className="survey-completion">
            <div className="completion-card">
              <h2>Survey Complete!</h2>
              <div className="score-display">
                <div className="score-value">{finalScore}</div>
                <div className="score-label">SUS Score</div>
              </div>
              <p className="completion-message">
                Thank you for your feedback. Your response has been recorded.
              </p>
              <button
                onClick={() => {
                  setSurveyCompleted(false);
                  setFinalScore(null);
                }}
                className="new-survey-button"
              >
                Submit Another Response
              </button>
            </div>
          </div>
        ) : (
          <div className="survey-wrapper">
            <SurveyForm
              onSubmitSuccess={handleSurveySuccess}
            />
          </div>
        )}
      </main>

      <footer className="app-footer">
        <p>&copy; 2025 Auricle Inc. All rights reserved.</p>
      </footer>
    </div>
  );
};
